import { IStateSocial } from '../../State/socialHelpers';

export class MapUtils {
    public static convertMapLeaderBoardScores(
        list: Array<unknown>,
        mapMultiplier: number
    ): Array<unknown> {
        let mapBoard: any[];
        mapBoard = list.filter((e: any) => {
            const perMap = e.score > 1000000 ? 1000000 : 10000;
            return Math.floor(e.score / perMap) === mapMultiplier;
        });
        mapBoard = mapBoard.filter(d => !d.user.isCurrentUser);
        mapBoard = mapBoard.slice(0, 20);
        mapBoard = mapBoard.map((e: any) => {
            const perMap = e.score > 1000000 ? 1000000 : 10000;
            let levelIndex = e.score - mapMultiplier * perMap;
            if (e.score > 1000000) {
                levelIndex = levelIndex / 10;
            }
            if (levelIndex < 1) {
                levelIndex = 1;
            }
            return {
                ...e,
                levelIndex,
            };
        });

        return mapBoard;
    }

    public static checkInvites(social: IStateSocial) {
        return social.confirmedInvitations.length > 0;
    }

    public static checkGiftFromFriend(social: IStateSocial) {
        return social.giftFromFriend !== '';
    }

    public static checkMessages(social: IStateSocial) {
        return (
            this.checkInvites(social) || this.checkGiftFromFriend(social) || social.gifts.length > 0
        );
    }
}
